export const FALSE = 'false';
export const TRUE = 'true';

export const FEATURE_FLAG_NAMES = {
  ADVANCED_TIMELINE_V2_ENABLED: 'advancedTimelineV2Enabled',
  AUDIO_TRIMMING_ENABLED: 'audioTrimmingEnabled',
  AUTO_LAYOUT_ENABLED: 'autoLayoutEnabled',
  BLUR_ENABLED: 'blurEnabled',
  CHAPTER_BREAKS_ENABLED: 'chapterBreaksEnabled',
  CHAPTER_BREAKS_SHOWN_BY_DEFAULT_ENABLED: 'chapterBreaksShownByDefaultEnabled',
  CLIP_FROM_SHOTS_ENABLED: 'clipFromShotsEnabled',
  CREATIVE_DIMENSIONS_CONTROL_ENABLED: 'creativeDimensionsControlEnabled',
  DEGRADED_SERVICE_BANNER_ENABLED: 'degradedServiceBannerEnabled',
  DESIGN_SWITCHING_ENABLED: 'designSwitchingEnabled',
  DOWNLOAD_CURRENT_FRAME: 'downloadCurrentFrame',
  EPISODE_MIN_SNAP_LENGTH_IN_SECONDS: 'episodeMinSnapLengthInSeconds',
  FPS_METER_ENABLED: 'fpsMeterEnabled',
  FRAME_EXTRACTION_VISUALIZER_ENABLED: 'frameExtractionVisualizerEnabled',
  FRAME_MANAGER_FOR_ALL_EXTRACTIONS_ENABLED:
    'frameManagerForAllExtractionsEnabled',
  LOCKED_LAYERS_ENABLED: 'lockedLayersEnabled',
  MAX_EPISODE_DURATION_IN_MINUTES: 'maxEpisodeDurationInMinutes',
  MIN_SNAP_DURATION_IN_SECONDS: 'minSnapDurationInSeconds',
  MAX_SNAP_DURATION_IN_SECONDS: 'maxSnapDurationInSeconds',
  MAX_VIDEO_PUBLICATION_DURATION_IN_MINUTES: 'maxVideoPublicationDuration',
  MULTI_VIDEO_CLIPS_ENABLED: 'multiVideoClipsEnabled',
  PRIMARY_BUTTON_COLOR: 'primaryButtonColor',
  SEND_TO_STORY_STUDIO_ENABLED: 'sendToStoryStudioEnabled',
  SINGLE_CANVAS_TIMELINE: 'singleCanvasTimeline',
  SNAP_CUT_ENABLED: 'snapCutEnabled',
  SNAP_PREVIEW_CANVAS_TEXT_ENABLED: 'snapPreviewCanvasTextEnabled',
  SNAP_PREVIEW_DEMO_ENABLED: 'snapPreviewDemoEnabled',
  RELEASE_NOTES_VERSION: 'releaseNotesVersion',
  TARGET_CHAPTER_LENGTH: 'targetChapterLengthInSeconds',
  TEMPLATE_FEATURE_CATEGORY: 'templateFeatureCategoryEnabled',
  TRIM_SNAP_TO_SELECTED_LAYER: 'trimSnapToSelectedLayer',
  VIS_MEDIA_UPLOAD_FOR_ALL_EDITORS_ENABLED:
    'visMediaUploadForAllEditorsEnabled',
};

export const PRIMARY_BUTTON_COLOR_NAMES = {
  BLUE: 'blue',
  YELLOW: 'yellow',
};

export const REDUX_NAMESPACE = 'FEATURE_FLAGS';
